import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Balances are stored as balances[currency][settlementData] = {balanceItem}
export interface GeneralState {
    showOverlay: boolean;
    systemStatus: 'healthy' | 'degraded' | 'down';
}

const initialState: GeneralState = {
    showOverlay: false,
    systemStatus: 'degraded' // Default to degraded until we fetch the actual status
};

export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setShowOverlay: (state, action: PayloadAction<boolean>) => {
            state.showOverlay = action.payload;
        },
        setSystemStatus: (state, action: PayloadAction<'healthy' | 'degraded' | 'down'>) => {
            state.systemStatus = action.payload;
        }
    }
});

export const { setShowOverlay, setSystemStatus } = generalSlice.actions;
export const selectShowOverlay = (state: RootState) => state.general.showOverlay;
export const selectSystemStatus = (state: RootState) => state.general.systemStatus;

export default generalSlice.reducer;
